export default ({
  userAddressRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
			const userAddresses = await userAddressRepository.fetch({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({userAddresses})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
